document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-cart-overlay]');
  let lastFocus;
  const root = window.Shopify?.routes?.root || '/';
  function closeCart() { drawer?.classList.remove('open'); overlay?.classList.remove('open'); document.body.style.overflow = ''; lastFocus?.focus(); }
  function openCart() { if (!drawer) return; lastFocus = document.activeElement; drawer.classList.add('open'); overlay?.classList.add('open'); document.body.style.overflow = 'hidden'; drawer.querySelector('button')?.focus(); }
  document.querySelectorAll('[data-cart-open]').forEach(el => el.addEventListener('click', e => { if (!drawer) return; e.preventDefault(); openCart(); }));
  document.querySelector('[data-cart-close]')?.addEventListener('click', closeCart);
  overlay?.addEventListener('click', closeCart);
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeCart();
    if (e.key !== 'Tab' || !drawer?.classList.contains('open')) return;
    const focusable = [...drawer.querySelectorAll('a, button, input')].filter(el => !el.disabled);
    const first = focusable[0], last = focusable.at(-1);
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last?.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first?.focus(); }
  });
  document.querySelectorAll('[data-quick-add], .quick-add-form').forEach(form => form.addEventListener('submit', async e => {
    e.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    let feedback = form.querySelector('[data-form-feedback]');
    if (!feedback) { feedback = document.createElement('p'); feedback.setAttribute('role', 'status'); feedback.className = 'form-feedback'; form.append(feedback); }
    button.disabled = true; feedback.textContent = '';
    try {
      const data = new FormData(form);
      const duo = form.querySelector('[data-matchie-pack]:checked')?.value === 'duo';
      const plan = data.get('selling_plan');
      if (!plan) data.delete('selling_plan');
      const planData = plan ? {selling_plan:Number(plan)} : {};
      const request = duo ? { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({items: [{id:55062719365459,quantity:1,...planData},{id:55062601957715,quantity:1,...planData}]}) } : {method:'POST',headers:{Accept:'application/json'},body:data};
      const response = await fetch(root + 'cart/add.js', request);
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || window.matchieI18n.addError);
      const cart = await fetch(root + 'cart.js').then(r => r.json());
      document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
      if (drawer) {
        const page = await fetch(window.location.href, { headers: { Accept: 'text/html' } }).then(r => r.text());
        const fresh = new DOMParser().parseFromString(page, 'text/html').querySelector('[data-cart-drawer]');
        if (fresh) { drawer.querySelector('.drawer-items').innerHTML = fresh.querySelector('.drawer-items').innerHTML; const foot = drawer.querySelector('.drawer-foot'); foot?.remove(); const newFoot = fresh.querySelector('.drawer-foot'); if (newFoot) drawer.append(newFoot); }
        openCart();
      } else window.location.assign(root + 'cart');
      feedback.textContent = window.matchieI18n.added;
    } catch (error) { feedback.textContent = error.message || window.matchieI18n.error; }
    finally { button.disabled = false; }
  }));
  document.querySelector('[data-variant-select]')?.addEventListener('change', e => { const price = document.querySelector('[data-product-price]'); if (price) price.textContent = e.target.selectedOptions[0].dataset.price; });
  function updatePackPrices(form) {
    const subscription = Boolean(form.querySelector('input[name="selling_plan"]:checked')?.value);
    const format = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:'EUR'}).format(cents / 100);
    form.querySelectorAll('[data-pack-pricing]').forEach(card => {
      card.querySelector('[data-pack-current]').textContent = format(Number(subscription ? card.dataset.regular : card.dataset.sale));
      const before = card.querySelector('[data-pack-before]');
      if (before) before.hidden = subscription;
    });
    form.querySelectorAll('[data-bundle-sale]').forEach(label => { label.hidden = subscription; });
    const chosen = form.querySelector('[data-matchie-pack]:checked')?.closest('.pack-card').querySelector('[data-pack-pricing]');
    const price = document.querySelector('[data-product-price]');
    if (chosen && price) price.textContent = format(Number(subscription ? chosen.dataset.regular : chosen.dataset.sale));
  }
  document.querySelectorAll('[data-matchie-pack], input[name="selling_plan"]').forEach(input => input.addEventListener('change', () => updatePackPrices(input.form)));
  document.querySelectorAll('[data-quantity-step]').forEach(button => button.addEventListener('click', () => {
    const input = button.closest('.cart-stepper').querySelector('input');
    input.value = Math.max(Number(input.min || 0), Number(input.value) + Number(button.dataset.quantityStep));
    input.dispatchEvent(new Event('change', {bubbles:true}));
  }));
  const menuButton = document.querySelector('[data-mobile-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  menuButton?.addEventListener('click', () => { const open = menuButton.getAttribute('aria-expanded') !== 'true'; menuButton.setAttribute('aria-expanded', String(open)); mobileMenu?.classList.toggle('open', open); if (mobileMenu) mobileMenu.style.display = open ? 'block' : 'none'; });
});




